// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Management",
  tabRestricted: "My statement",
  restrictedTitle: "My statement",

  pageFilters: {
    ownership: "Accommodations",
    ownershipAll: "Managed and own",
    ownershipManaged: "Managed only",
    ownershipOwn: "Own only",
    owner: "Owner",
    allOwners: "All owners",
  },

  views: {
    business: "My business",
    owners: "Owners",
    expenses: "Expenses",
  },

  filters: {
    listings: "Listings",
    allListings: "All",
    someListings: "{count} listings",
    owner: "Owner",
    allOwners: "All",
    attribution: "Count bookings by",
    checkout: "Check-out date",
    checkin: "Check-in date",
    nights: "Nights in the period",
    attributionHelp: "By check-out is how owners are settled: the stay is already over.",
    attributionHelpLabel: "What “Count bookings by” means",
    currency: "Currency",
  },

  warnings: {
    otaEstimated:
      "{count} booking with the OTA commission estimated by percentage: the channel didn't report the actual one. | {count} bookings with the OTA commission estimated by percentage: the channel didn't report the actual one.",
    noBreakdown:
      "{count} booking without a breakdown: its full amount has been counted as accommodation. | {count} bookings without a breakdown: their full amount has been counted as accommodation.",
    outdatedBreakdown:
      "{count} booking was edited or extended after being imported: its current amount has been used. | {count} bookings were edited or extended after being imported: their current amount has been used.",
    otherCurrencies: "Some accommodations use another currency ({currencies}). Switch it above to see them.",
    noOwner:
      "{count} managed accommodation has no owner assigned. | {count} managed accommodations have no owner assigned.",
    assignOwners: "Assign owners",
  },

  states: {
    loadError: "The management data couldn't be loaded.",
    forbidden: "You don't have permission to see this information.",
    periodTooLong: "Choose a period of two years at most.",
    retry: "Retry",
    noMovements: "No activity in this period",
  },

  empty: {
    title: "Do you manage accommodations for other owners?",
    text: "Mark each accommodation you manage on behalf of an owner and set your terms: your commission, who collects the bookings and how cleaning is handled. Here you'll see what you earn and what each owner is due.",
    point1: "Your commissions, cleaning and expenses, with your real profit",
    point2: "What to transfer to or collect from each owner",
    point3: "Each owner's statement in PDF or Excel",
    cta: "Set up my accommodations",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "bookings by check-out date",
    byCheckin: "bookings by check-in date",
    byNights: "nights in the period",
    day: "by day",
    week: "by week",
    month: "by month",
  },

  counts: {
    reservations: "{count} booking | {count} bookings",
    nights: "{count} night | {count} nights",
    units: "{count} accommodation | {count} accommodations",
    ownUnits: "{count} own accommodation | {count} own accommodations",
    owners: "{count} owner | {count} owners",
  },

  business: {
    kpi: {
      managedGross: "Managed revenue",
      commissions: "Your commissions",
      cleaning: "Cleaning",
      ownRevenue: "Own properties revenue",
      expenses: "Expenses",
      profit: "Profit",
    },
    vatLine: "+ VAT {amount}",
    ofTotal: "of total revenue",
    overManaged: "of managed revenue",
    ofIncome: "of your income",
    margin: "margin",
    chartTitle: "Income, expenses and profit",
    chartA11y: "Chart of income, expenses and profit for the period",
    legend: {
      commissions: "Commissions",
      cleaning: "Cleaning",
      own: "Own properties",
      expenses: "Expenses",
      profit: "Profit",
    },
    byCategory: "Expenses by category",
    category: "Category",
    amount: "Amount",
    noExpenses: "No expenses in this period",
    seeExpenses: "See expenses",
  },

  owners: {
    kpi: {
      gross: "Booking revenue",
      ota: "OTA commissions",
      cleaning: "Cleaning",
      commission: "Your commission + VAT",
      commissionRestricted: "Manager's commission + VAT",
      charged: "Expenses charged to owners",
      net: "Net to owners",
      netRestricted: "Your net",
    },
    ofGross: "of revenue",
    collectedByYou: "collected by you",
    collectedByManager: "collected by your manager",
    commissionLine: "{commission} + VAT {vat}",
    otaLine: "{commission} + VAT {vat}",
    otaTitle: "OTA commission {commission} + VAT {vat}",
    commissionTitle: "Commission {commission} + VAT {vat}",
    toTransfer: "To transfer to owners",
    toCollect: "To collect from owners",
    toTransferRestricted: "Your manager transfers to you",
    toCollectRestricted: "To pay your manager",
    chartTitle: "How the revenue was split",
    chartA11y: "Chart of how the revenue from managed bookings was split",
    legend: {
      net: "Net to owners",
      netRestricted: "Your net",
      commissions: "Your commissions",
      commissionsRestricted: "Manager's commission",
      ota: "OTA commissions",
      cleaning: "Cleaning",
      other: "Taxes, deposits, VAT and expenses",
    },
    grossFooter: "Revenue: {amount}",
    tableTitle: "Statement by owner",
    tableTitleRestricted: "Your statement in detail",
    downloadAll: "Download all (PDF)",
    download: "Download (PDF)",
    downloading: "Downloading…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "The statement couldn't be downloaded.",
    cols: {
      owner: "Owner",
      reservations: "Bookings",
      gross: "Revenue",
      ota: "OTA",
      cleaning: "Cleaning",
      commission: "Commission + VAT",
      charged: "Expenses",
      net: "Net",
      balance: "Balance",
      actions: "Downloads",
    },
    noOwner: "No owner assigned",
    transfer: "Transfer {amount}",
    collect: "Collect {amount}",
    receive: "To receive {amount}",
    pay: "To pay {amount}",
    collectionManager: "Manager collects",
    collectionOwner: "Owner collects",
    total: "Total",
    expand: "Show details for {name}",
    collapse: "Hide details for {name}",
    iban: "IBAN {iban}",
    showReservations: "See bookings ({count})",
    hideReservations: "Hide bookings",
    noData: "No managed bookings in this period.",
    reservations: {
      checkIn: "Check-in",
      checkOut: "Check-out",
      guest: "Guest",
      listing: "Accommodation",
      channel: "Channel",
      gross: "Revenue",
      ota: "OTA",
      cleaning: "Cleaning",
      commission: "Commission",
      vat: "VAT",
      net: "Net",
      direct: "Direct",
      estimated: "est.",
      estimatedHelp: "Estimated by percentage: the channel didn't report the actual commission.",
      noBreakdown: "no breakdown",
      noBreakdownHelp: "The booking has no breakdown: its full amount has been counted as accommodation.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Loading bookings…",
      loadError: "The bookings couldn't be loaded.",
      empty: "No bookings in this period.",
    },
    charged: {
      title: "Expenses charged to the owner",
      date: "Date",
      concept: "Description",
      listing: "Accommodation",
      amount: "Amount",
      general: "General",
    },
  },

  a11y: {
    views: "Management sections",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Price",
    comision: "OTA commission",
    tasas: "Taxes",
    limpieza: "Cleaning",
    honorarios: "Fees",
    honorariosIva: "Fees + VAT",
    neto: "Owner net",
    transfieres: "You transfer",
    tePaga: "Owner pays you",
    recibes: "You receive",
    pagas: "You pay",
    netoPropietarios: "Net for owners",
    formula: "Income = Price − Commission · Total = Income − Taxes − Cleaning · Net = Total − Fees − VAT. Same as the PDF and Excel.",
    cols: {
      origen: "Source",
      nombre: "Name",
      entrada: "Check-in",
      salida: "Check-out",
      precio: "Price",
      noches: "Nights",
      comision: "Commission",
      ingreso: "Income",
      tasas: "Taxes",
      limpieza: "Cleaning",
      total: "Total",
      honorarios: "Fees",
      iva: "VAT",
      neto: "Net",
    },
  },
};
